import 'babel-polyfill';
import Vue from 'vue';
import './scss/main.scss'
import Resource from './components/Resource.vue';

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

new Vue({
  delimiters: ['%%', '%%'],
  el: '#app',
  components: {
    Resource,
  }
});